// import axios from "axios";
// import {createContext, useContext} from "react";
//
// const client = axios.create({
//     baseURL: process.env.REACT_APP_API_URL,
//     headers: {
//         'Content-Type': 'application/json',
//     },
// });
//
// const ClientContext = createContext(client);
//
// export const ClientProvider = ({ children }) => {
//
//     return (
//         <ClientContext.Provider value={client}>
//             {children}
//         </ClientContext.Provider>
//     );
// }
//
// export const useClient = () => useContext(ClientContext);

// export const useClient = () => {
//     const { authToken, logout } = useAuth();
//
//     // Add a request interceptor
//     client.interceptors.request.use(
//         (config) => {
//             if (authToken) {
//                 config.headers['Authorization'] = `Bearer ${authToken}`;
//             }
//             return config;
//         },
//         (error) => {
//             // Handle the error
//             return Promise.reject(error);
//         }
//     );
//
//     client.interceptors.response.use(
//         (response) => {
//             // Any status code that lie within the range of 2xx cause this function to trigger
//             return response;
//         },
//         (error) => {
//             if (error.response && error.response.status === 401) {
//                 // Call the logout function if a 401 error is received
//                 logout();
//             }
//             return Promise.reject(error);
//         }
//     );
//
//
//     return client;
// };

// src/core/client.js
import axios from "axios";
import React, {createContext, useContext, useLayoutEffect, useRef} from "react";
import {useAuth} from "../auth-context"; // adjust the import path to your actual auth hook

const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

const ClientContext = createContext(client);

export const ClientProvider = ({ children }) => {
    const { authToken, logout } = useAuth?.() ?? {};
    const clientRef = useRef(client);

    useLayoutEffect(() => {
        const currentClient = clientRef.current;
        // Add/refresh interceptors whenever authToken changes
        const reqId = currentClient.interceptors.request.use((config) => {
            if (authToken) {
                config.headers = config.headers || {};
                config.headers["Authorization"] = `Bearer ${authToken}`;
            } else if (config.headers && config.headers["Authorization"]) {
                delete config.headers["Authorization"];
            }
            return config;
        });

        const respId = currentClient.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error?.response?.status === 401) {
                    try { logout?.(); } catch (_) {}
                }
                return Promise.reject(error);
            }
        );

        return () => {
            currentClient.interceptors.request.eject(reqId);
            currentClient.interceptors.response.eject(respId);
        };
    }, [authToken, logout]);

    return (
        <ClientContext.Provider value={clientRef.current}>
            {children}
        </ClientContext.Provider>
    );
};

export const useClient = () => useContext(ClientContext);
